import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";
import { useRecoilState } from "recoil";

import { MontageCredits } from "../../../MontageCreditsDropdown";
import { Tooltip } from "../../../Tooltip";
import { CreatorCreditIcon } from "../../../../Views/Pricing/Components/Table/CreatorCreditIcon";
import { LedgerState } from "../../../../State/ledger";

const Credits = () => {
  const [ledgerState] = useRecoilState(LedgerState);

  return (
    <CurrencySection>
      <DropdownContainer
        type="click"
        position={{
          top: "40px",
          left: "-190px",
        }}
        tooltipContent={<MontageCredits />}
      >
        <CreditsClickable>
          <CreatorCreditIcon
            tooltipPosition="bottom"
            addMargin={false}
            size={20}
          />
          <TotalCreditsContainer>
            <Box>{ledgerState.localBalance}</Box>
          </TotalCreditsContainer>
        </CreditsClickable>
      </DropdownContainer>
    </CurrencySection>
  );
};

const TotalCreditsContainer = styled(Flex)`
  align-items: center;
  background-color: ${(props) => props.theme.colors.turboAlpha10};
  border-radius: 6px;
  color: ${(props) => props.theme.colors.turbo};
  font-size: 14px;
  font-weight: 700;
  height: 24px;
  justify-content: center;
  min-width: 24px;
  padding: 5px;
`;

const CreditsClickable = styled(Flex)`
  align-items: center;
  border-radius: 8px;
  gap: 8px;
  justify-content: center;
  width: 70px;

  &:hover {
    background: ${(props) => props.theme.colors.darkerNed};
    cursor: pointer;
  }
`;

const DropdownContainer = styled(Tooltip)`
  &:hover {
    cursor: default;
  }

  @media (max-width: ${(props) => props.theme.breaks.medium}) {
    padding: 0;
  }
`;

const CurrencySection = styled(Flex)`
  background: ${({ theme }) => theme.colors.grey850};
  border-radius: 12px;
  padding: 6px;
`;

export { Credits };
